export const useInterceptors = <T>(interceptors: Array<(data: T) => T | Promise<T>>) => (
  interceptors.reduce((chain, fn) => async (data: T): Promise<T> => {
    const result = await chain(data);
    return fn(result);
  }, (data: T) => Promise.resolve(data))
);
